export enum RequestStatusEnum {
  INCOMING = 'Incoming',
  FULFILLED = 'Fulfilled',
  CANCELLED = 'Cancelled',
  DEFERRED = 'Deferred',
}
